export default __webpack_public_path__ + "static/media/dim_logo_blanco.b62cfcc6.svg";